<template>
  <div class="about" oncontextmenu="return false">
      <!-- <Navbar></Navbar> -->
      <div class="contents"> 
          <div class="bg"> </div>
          <div class="content">
              <div class="middle">
                  <div class="aboutus">
                      <span class="line"></span>
                      <div class="title">关于我们</div>
                      <p>ABOUT US</p>
                      <span class="line"></span>
                  </div>
                  <div class="intro">
                      <div class="cn">广州扬盛计算机软件有限公司，成立于2009年，是国内首家研发生产网络版移动支付投币设备的企业，并拥有多项国家专利技术。公司技术开发团队实力雄厚，研发的维码器在市场上具有极高的口碑及影响力，是移动支付投币领域的引领者。</div>
                      <div class="eg">Guangzhou Yang Sheng Computer Software Co. Ltd. was founded in 2009, which is the first company in China to develop and produce online version of mobile payment coin-operated equipment. It has a number of national patent technologies. The company's technical development team is very strong and research and development code device has a high reputation and influence in the market. It is the leader in the field of mobile payment coin.</div>
                  </div>
                  <div class="bottons">
                      <div class="botton">
                        <span class="longline"></span>
                        <p>扬盛科技</p>
                    </div>
                  </div>
                  <div class="photo"></div>
                  
              </div>
              <thr></thr>
          </div>
           
      </div>
     <foot></foot>
  </div>
</template>

<script>
import Navbar from '../Navbar'
import Foot from '../hardProduct/foot'
import Thr from './thr'
export default {
  name:'about',
  components:{Navbar,Foot,Thr},
  mounted(){
      this.$store.state.hardDot = false
        this.$store.state.homeDot = false
        this.$store.state.softDot = false
        this.$store.state.coopDot = false
        this.$store.state.aboutDot = true
      this.$store.state.d4 = ''
  }
}
</script>


<style scoped>
/* .contents .bg .header{
    position: absolute;
    z-index: 0;
} */
.contents{
    width: 100%;
}
.contents .bg{
    width: 100%;
    height: 800px;
    background: url(./images/bg1.jpg) no-repeat;
    background-size: cover;
}
.content{
    width:100%;
    height: 100%;   /*为什么写100%没有高度呢*/
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.middle{
    width: 1200px;
	height: 1100px;
	background-color: #ffffff;
    margin-top: -200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
}
.aboutus{
    width: 499px;
	height: 133px;
    background: url(images/titlebg.png) no-repeat;
    background-size: 499px 78px;
    background-position: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    margin-top: 100px;
}
.aboutus .line{
    width: 24px;
	height: 3px;
	background-color: #1a8bff;
    display: block;
}
.aboutus .title{
    font-family: 微软雅黑;
    font-size: 40px;
	letter-spacing: 0px;
	color: #333333;
}
.aboutus p{
    font-size: 14px;
	font-family: Arial;
	letter-spacing: 1px;
	color: #333333;
    display: block;
    margin-top: -18px;
}
.intro{
    width: 800px;
	height: 282px;
    line-height: 36px;
}
.intro .cn{
    font-size: 16px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
    color: #999999;
    text-align: justify;
}
.intro .eg{
    font-size: 16px;
	font-family: Arial;
	letter-spacing: 0px;
    color: #999999;
    text-align: justify;
}
.bottons {
    width: 800px;
    height: 15px;
    display: flex;
    justify-content: flex-end;
}
.botton .longline{
    width: 70px;
	height: 2px;
	background-color: #cccccc;
    display: block;
}
.botton{
    width: 156px;
	height: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.botton p{
    font-size: 16px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #666666;
}
.photo{
    width:1200px;
    height: 300px;
    background: url(images/xs1.png) no-repeat;
    background-size: cover;
}
/* 手机 */
@media screen and (max-width:768px){
.about .header{
    display: none;
}
.about{
    margin-top: 48px;
}
.contents .bg{
width: 100%;
height: 205px;
background: url(./images/phone/BG1.png) no-repeat;
background-size: 100%;
}
.middle{
    width: 90%;
    /* height: 100%; */
    height: auto;
    margin-top: -70px;
}
.aboutus{
    width: 80%;
	height: 66px;
    background: url(images/titlebg.png) no-repeat;
    background-size: 249px 39px;
    background-position: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    margin-top: 35px;
}
.aboutus .line{
    width: 12px;
	height: 1.5px;
	background-color: #1a8bff;
    display: block;
}
.aboutus .title{
    font-family:'Times New Roman', Times, serif;
    font-size: 20px;
	letter-spacing: 0px;
	color: #333333;
}
.aboutus p{
    font-size: 7px;
	font-family: Arial;
	letter-spacing: 1px;
	color: #333333;
    display: block;
    margin-top: -9px;
}
.intro{
    width: 90%;
    /* height: 100%; */
        margin-top: 38px;
}
.intro .cn{
    font-size: 11px;
	line-height: 22px;
	letter-spacing: 0px;
	color: #666666;
}
.intro .eg{
    font-size: 11px;
	font-family: Arial;
	letter-spacing: 0px;
    color: #999999;
    line-height: 22px;
        margin-top: 10px;
}
.bottons{
    width: 90%;
    margin-top: 40px;
}
.botton .longline{
    width: 35px;
	height: 1px;
	background-color: #cccccc;
    display: block;
}
.botton{
    width: 90px;
}
.botton p{
    font-size: 11px;
	font-family:'Times New Roman', Times, serif;
	letter-spacing: 0px;
	color: #666666;
}
.middle .photo{
    width: 100%;
    height: 86px;
    background-size: 100%;
    background-position: center;
    margin-top: 45px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs/about.vue